import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Badge from '@atlaskit/badge';
import StarIconFilled from '@atlaskit/icon/glyph/star-filled';
import { LinkUtils } from '@atlassian/mpac-utils';
import React, { Component } from 'react';
import { shortFormat } from "../utils/Numeral";
import { FILL_MAP, GREY_STAR, HALF_STAR, HALF_STAR_GRADIENT_HOVER_ID, HALF_STAR_GRADIENT_ID, YELLOW_STAR } from "./Ratings.constants";
import { AverageRating, HalfStarGradientContainer, RatingContainer, RatingsCount, StarIconContainer } from "./Ratings.styles";
import { getStarCounts } from "./Ratings.utils";

const HalfStarGradient = props => /*#__PURE__*/React.createElement(HalfStarGradientContainer, null, /*#__PURE__*/React.createElement("linearGradient", {
  id: props.id
}, /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: props.primaryColor
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: props.secondaryColor
})));

export default class Ratings extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getStarVariations", () => {
      const averageStars = this.props.ratings.avgStars;
      const {
        yellowStarsCount,
        halfStarsCount,
        greyStarsCount
      } = getStarCounts(averageStars);
      return [...new Array(yellowStarsCount).fill(YELLOW_STAR), ...new Array(halfStarsCount).fill(HALF_STAR), ...new Array(greyStarsCount).fill(GREY_STAR)];
    });

    _defineProperty(this, "getStars", clickable => this.getStarVariations().map((variation, index) => /*#__PURE__*/React.createElement(StarIconContainer, {
      key: index,
      clickable: clickable,
      variation: variation
    }, /*#__PURE__*/React.createElement(StarIconFilled, null))));

    _defineProperty(this, "onRatingsClick", e => {
      const {
        onClick
      } = this.props;

      if (onClick) {
        LinkUtils.maybeOpenInNewTab(e, () => {
          e.stopPropagation();
          onClick();
        });
      }
    });
  }

  render() {
    const numRatings = this.props.ratings.numRatings;
    const clickable = !!this.props.onClick;
    const stars = this.getStars(clickable);
    return /*#__PURE__*/React.createElement(RatingContainer, {
      onClick: this.onRatingsClick,
      clickable: clickable
    }, /*#__PURE__*/React.createElement(HalfStarGradient, {
      id: HALF_STAR_GRADIENT_ID,
      primaryColor: FILL_MAP[YELLOW_STAR].fill,
      secondaryColor: FILL_MAP[GREY_STAR].fill
    }), /*#__PURE__*/React.createElement(HalfStarGradient, {
      id: HALF_STAR_GRADIENT_HOVER_ID,
      primaryColor: FILL_MAP[YELLOW_STAR].fillHover,
      secondaryColor: FILL_MAP[GREY_STAR].fillHover
    }), /*#__PURE__*/React.createElement(AverageRating, null, stars), numRatings && this.props.showRatingCount ? /*#__PURE__*/React.createElement(RatingsCount, null, /*#__PURE__*/React.createElement(Badge, null, "".concat(shortFormat(numRatings)))) : null);
  }

}

_defineProperty(Ratings, "defaultProps", {
  showRatingCount: true
});